import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {setCapsuleNotesModalStatus} from "../../../store/cabinet/action";
import {isCapsuleLocked, isCapsuleSealed, pluralHandler} from "../../../helpers/capsule";

const CabinetCapsuleNotes = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const capsuleStats = useSelector(store => store.cabinet.capsuleStats);

    const notes = capsuleStats?.stats?.notes;
    const count = notes?.count || 0;
    // пока капсула не куплена, раздел закрыт
    const isLocked = isCapsuleLocked(capsuleStats?.capsule_status);
    // запечатанную капсулу уже не дополняют: раздел открывается только на чтение
    const isSealed = isCapsuleSealed(capsuleStats?.capsule_status);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardHead}`}>
                        <div className={`${Styles.cardTitle}`}>{t('Заметки')}</div>
                        {!isLocked ? (
                            <div className={`${Styles.cardChip}`}>
                                {count} {pluralHandler(count, [t('заметка'), t('заметки'), t('заметок')])}
                            </div>
                        ) : null}
                    </div>

                    <div className={`${Styles.cardNote}`}>
                        {t('Свободный текст о вас — дополняет анкету и материалы')}
                    </div>

                    <div
                        className={`${Styles.cardBtn} ${isLocked || isSealed ? Styles.cardBtnDsb : ''}`}
                        onClick={()=>{
                            if (!isLocked && !isSealed && capsuleStats){
                                dispatch(setCapsuleNotesModalStatus(true));
                            }
                        }}
                    >
                        {isSealed ? t('Запечатано') : t('Открыть заметки')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetCapsuleNotes;
